import { render, staticRenderFns } from "./FormsPA.vue?vue&type=template&id=60b1b504&"
import script from "./FormsPA.vue?vue&type=script&lang=js&"
export * from "./FormsPA.vue?vue&type=script&lang=js&"
import style0 from "./FormsPA.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports